import { Auxiliares } from "../../types/TabelasAuxiliares/Auxiliares";
import api from "../../utils/api";
import { INDICATOR_DATA_PERIOD_URL } from "../../utils/endpoints";

export async function getDataPeriod(parentId: number) {
  try {
    const response = await api.get(
      `${INDICATOR_DATA_PERIOD_URL}?OnlyActive=true${parentId ? `&ParentId=${parentId}` : ""}`,
    );
    const data: Auxiliares[] = response.data.map((option: Auxiliares) => ({
      id: option.id,
      name: option.name,
      code: option.code,
      isActive: option.isActive,
    }));
    return data;
  } catch (error) {
    throw error;
  }
}
